import strings from 'strings';
import { SendoverStatus } from 'UI/constants/status';

const { title: STRINGS } = strings.sendoutsV2.drawers.declinationReasons;

export const REASONS_TITLE_BY_STATUS = {
  [SendoverStatus.Active]: STRINGS.sendoverReasons,
  [SendoverStatus.NoOffer]: STRINGS.noOffer,
  [SendoverStatus.Declined]: STRINGS.declination
};
